import React from 'react'

function SignUp() {
    return (

<div className="page-content pb-0">
  <div data-card-height="cover" className="card" style={{height: 898}}>
    <div className="card-top notch-clear">
      <div className="d-flex">
        <a href="#" data-back-button className="me-auto icon icon-m"><i className="font-14 fa fa-arrow-left color-theme" /></a>
        <a href="#" data-toggle-theme className="show-on-theme-light ms-auto icon icon-m"><i className="font-12 fa fa-moon color-theme" /></a>
        <a href="#" data-toggle-theme className="show-on-theme-dark ms-auto icon icon-m"><i className="font-12 fa fa-lightbulb color-yellow-dark" /></a>
      </div>
    </div>
    <div className="card-center">
      <div className="ps-5 pe-5">
        <h1 className="text-center font-800 font-40 mb-1">Sign Up</h1>
        <p className="color-highlight text-center font-12">Create an Account. It's free!</p>
        <div className="input-style no-borders has-icon validate-field">
          <i className="fa fa-user" />
          <input type="name" className="form-control validate-name" id="form1a" placeholder="Name" />
          <label htmlFor="form1a" className="color-blue-dark font-10 mt-1">Name</label>
          <i className="fa fa-times disabled invalid color-red-dark" />
          <i className="fa fa-check disabled valid color-green-dark" />
          <em>(required)</em>
        </div>
        <div className="input-style no-borders has-icon validate-field mt-2">
          <i className="fa fa-at" />
          <input type="email" className="form-control validate-name" id="form1aa" placeholder="Email" />
          <label htmlFor="form1aa" className="color-blue-dark font-10 mt-1">Email</label>
          <i className="fa fa-times disabled invalid color-red-dark" />
          <i className="fa fa-check disabled valid color-green-dark" />
          <em>(required)</em>
        </div>
        <div className="input-style no-borders has-icon validate-field mt-2">
          <i className="fa fa-lock" />
          <input type="password" className="form-control validate-text" id="form3a" placeholder="Choose a Password" />
          <label htmlFor="form3a" className="color-blue-dark font-10 mt-1">Choose a Password</label>
          <i className="fa fa-times disabled invalid color-red-dark" />
          <i className="fa fa-check disabled valid color-green-dark" />
          <em>(required)</em>
        </div>
        <div className="input-style no-borders has-icon validate-field mt-2">
          <i className="fa fa-lock" />
          <input type="password" className="form-control validate-text" id="form3a1" placeholder="Confirm your Password" />
          <label htmlFor="form3a1" className="color-blue-dark font-10 mt-1">Confirm your Password</label>
          <i className="fa fa-times disabled invalid color-red-dark" />
          <i className="fa fa-check disabled valid color-green-dark" />
          <em>(required)</em>
        </div>
        <div className="text-center mb-5 mt-5">
          <a href="page-signin-2.html" className="font-12">Already Registered? Sign in Here</a>
        </div>
        <a href="#" className="back-button btn btn-full btn-m shadow-large rounded-sm text-uppercase font-900 bg-highlight">Create Account</a>
      </div>
    </div>
  </div>
</div>


    )
}

export default SignUp